import dayjs from 'dayjs';
import { ControlledDatePicker } from '../../../../shared/components';

/** The job's contacts a quotation can be addressed to, as `job_quotes.quote_to` stores them. */
export const QUOTE_TO = {
  CLIENT: 'CLIENT',
  ARCHITECT: 'ARCHITECT',
  BUILDER: 'BUILDER',
  OWNER: 'OWNER',
} as const;

/** Form values the section starts from: dated today, addressed to the client. */
export function quotationHeaderDefaults() {
  return { quoteDate: dayjs().format('YYYY-MM-DD'), quoteTo: QUOTE_TO.CLIENT };
}

/**
 * The quotation letter's date. It may be backdated but never later than today. The letter is
 * addressed to the client: the "Quotation To" choice was taken off the screen, so `quoteTo`
 * stays at its CLIENT default.
 */
export default function QuotationHeaderSection() {
  return (
    <div className='row gap-5 items-start' style={{ flexWrap: 'wrap' }}>
      <ControlledDatePicker
        id='quoteDate'
        name='quoteDate'
        label='Quotation Date*'
        disableFuture
        maxDate={dayjs()}
        rules={{
          required: 'Quotation date is required',
          validate: (v: string | null) =>
            !v || !dayjs(v).isAfter(dayjs(), 'day') || 'The quotation date cannot be in the future',
        }}
        sx={{ maxWidth: 260 }}
      />
    </div>
  );
}
